/**
 * lib/views/javascripts/login.js — the sign-in page's entry module
 * (lib/views/htmls/login.ejs; ADR 0082 D3).
 *
 * Runs once the page is parsed, in the order the page has always run them:
 * bind passkey sign-in and the post-sign-in offer (they were classic scripts
 * that ran first), clear stale service workers, bind the password eye, mark
 * and diagnose login loops, then take over the form for the boot transition. Server values
 * (the push worker path, the canary cookie name) arrive as boot data.
 *
 * Contents: view
 * Ontology: Code object M33C-1031 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

import { readBootData } from './shared/boot-data.js';
import { bustServiceWorkers } from './login/service-worker.js';
import { bindPasswordEye } from './login/password-eye.js';
import { markLoginAttempts, showLoopDiagnostic } from './login/login-loop.js';
import { startBootTransition } from './login/boot-transition.js';
import { passkeys } from './shared/passkeys.js';
import { bindLoginPasskeys } from './login/passkeys.js';

// ── Start ────────────────────────────────────────────────────────────────
const boot = readBootData();
bindLoginPasskeys(passkeys(), window);
bustServiceWorkers(boot.pushWorkerPath);
bindPasswordEye();
markLoginAttempts();
showLoopDiagnostic(boot.canaryName);
startBootTransition();
